module.exports = __webpack_public_path__ + "static/media/faq_active.8ed7d6f2.svg";